import { useKernelApi } from 'infrastructure/api';
import { ResourceData } from 'framework/crud';

export const FEEDBACKS_ABOUT_ME = 'READ_FEEDBACKS_ABOUT_ME';

const useEmployeeFeedbacksService = () => {
  const { sendPostRequest } = useKernelApi();

  const search = async (request: ResourceData) => {
    const url = `/employees/my/feedbacks/search`;

    const response = await sendPostRequest(url, request);
    return response.json();
  };

  return {
    search,
  };
};

export default useEmployeeFeedbacksService;
